import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, UsersService } from '@app/core/services';
import { loadUser } from '@app/core/store/actions/user.actions';
import { AppState } from '@app/core/store/reducers';
import { Store } from '@ngrx/store';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';

@Component({
  standalone: false,
  templateUrl: './login.component.html'
})
export class LoginComponent {

  isRendered = false;

  constructor(@Inject(OKTA_AUTH) private readonly oktaAuth: OktaAuth, private readonly store: Store<AppState>,
    private readonly router: Router, private readonly authService: AuthService, private readonly userService: UsersService) {
    this.init();
  }

  async init() {
    await this.userService.pubtk();
    const isSession = await this.authService.checkSession();
    if (isSession) {
      this.isRendered = false;
      const accessToken = this.oktaAuth.tokenManager.getTokensSync()?.accessToken?.accessToken;
      if (accessToken) {
        this.authService.ttoc().then(() => {
          this.store.dispatch(loadUser());
          this.authService.routeToDefault();
        }).catch(e => {
          console.error('ttoc call failed');
          this.router.navigate(['/']);
        });
      } else {
        this.authService.routeToDefault();
      }
    } else {
      this.isRendered = true;
    }
  }

  public async signIn(): Promise<void> {
    this.oktaAuth.setOriginalUri(this.router.url);
    await this.oktaAuth.signInWithRedirect();
  }
}